import '../index.scss';

import clsx from 'clsx';
import { forwardRef, useContext } from 'react';

import { OpenPanelOptions, PanelsContext } from '../panel/PanelsContext';
import { RibbonButton, RibbonButtonProps } from './RibbonButton';

export type RibbonButtonOpenPanelProps = Omit<RibbonButtonProps, 'onClick'> & OpenPanelOptions;
export const RibbonButtonOpenPanel = forwardRef<HTMLButtonElement, RibbonButtonOpenPanelProps>(
  function RibbonButtonOpenPanel({ uniqueId, componentFn, poppedOut, onClose, className, ...buttonProps }, ref) {
    const { openPanel, openPanels } = useContext(PanelsContext);

    return (
      <RibbonButton
        ref={ref}
        {...buttonProps}
        onClick={() => openPanel({ uniqueId: uniqueId || buttonProps.title, componentFn, poppedOut, onClose })}
        className={clsx(openPanels.has(uniqueId ?? '') && 'RibbonButton-selected', className)}
      />
    );
  },
);
